import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError } from 'rxjs/operators';

import { environment } from '@env/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class AuthService {

  private apiUrl = environment.auth.endpoints.base;  // URL to web api

  constructor(private http: HttpClient) { }

  /** PUT: update user */
  public activate(data: any): Observable<any> {
      var url=this.apiUrl+'activate';
    return this.http.post(url, data, httpOptions)
      .pipe(
        catchError(this.handleError('updateUser'))
      );
  }


  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
       // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
